import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import { restActionFactory } from "../../toolkit/axiosActions/axiosActionsFactory";
import axios from "axios";
import FileDownload from "js-file-download";
import { errorNotification } from "../../utils/notifications";
import { deleteEmptyProps } from "../../toolkit/utils/filter-utils";

const TOTAL_PASS_BASE_URL = "/api/total-pass";

// Limpieza de invitados
export const clearTotalPassList = (): IAction => {
  return {
    type: actionTypes.CLEAR_TOTAL_PASS_LIST,
    payload: true
  };
};

// Limpieza de invitado
export const clearTotalPass = (): IAction => {
  return {
    type: actionTypes.CLEAR_TOTAL_PASS,
    payload: true
  };
};

export const getTotalPassList = (filters: any): IAction => {
  return totalPassRestAction({
    actionType: actionTypes.GET_TOTAL_PASS_LIST,
    method: "get",
    params: deleteEmptyProps(filters)
  });
};

export const getTotalPass = (idPersona): IAction => {
  return totalPassRestAction({
    actionType: actionTypes.GET_TOTAL_PASS,
    urlComplement: `/${idPersona}`,
    method: "get"
  });
};

// Limpieza de movimientos
export const clearMovimientosTotalPass = (): IAction => {
  return {
    type: actionTypes.CLEAR_MOVIMIENTOS_TOTAL_PASS,
    payload: true
  };
};

export const getMovimientosTotalPass = (idPersona): IAction => {
  return totalPassRestAction({
    actionType: actionTypes.GET_MOVIMIENTOS_TOTAL_PASS,
    urlComplement: `/${idPersona}/movimientos`,
    method: "get"
  });
};

// Limpieza de bitácora
export const clearBitacoraTotalPass = (): IAction => {
  return {
    type: actionTypes.CLEAR_BITACORA_TOTAL_PASS,
    payload: true
  };
};

export const getBitacoraTotalPass = (idPersona): IAction => {
  return totalPassRestAction({
    actionType: actionTypes.GET_BITACORA_TOTAL_PASS,
    urlComplement: `/${idPersona}/bitacora`,
    method: "get"
  });
};

export const getClubesAccesoTotalPass = (idPersona): IAction => {
  return totalPassRestAction({
    actionType: actionTypes.GET_CLUBES_ACCESO_TOTAL_PASS,
    urlComplement: `/${idPersona}/clubes-acceso`,
    method: "get"
  });
};

/**
 * Baja de app TotalPass.
 * BFF: DELETE /api/total-pass/personas/{idPersona}/baja-app?userId={userId}
 */
export const deleteBajaAppTotalPass = (
  idPersona: number | string,
  userId?: number | string
): IAction => {
  return {
    type: actionTypes.DELETE_TOTAL_PASS_BAJA_APP,
    payload: axios.delete(
      `${constants.BASE_URL}${TOTAL_PASS_BASE_URL}/personas/${idPersona}/baja-app`,
      {
        withCredentials: true,
        params: userId != null && userId !== "" ? { userId } : undefined
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getReporteTotalPasss = (filters: any, callback: any) => {
  return axios
    .get(`${constants.BASE_URL}${TOTAL_PASS_BASE_URL}/reporte/descargar`, {
      withCredentials: true,
      responseType: "blob",
      params: deleteEmptyProps(filters)
    })
    .then(({ data }) => {
      FileDownload(data, `ReporteTotalPasss.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const getTotalPassAsistencias = idPersona => {
  const url = `${constants.BASE_URL}${TOTAL_PASS_BASE_URL}/${idPersona}/asistencias`;
  const config = { withCredentials: true };
  return axios.get(url, config);
};

// Construye una instancia de RestAction para Redux, para manipular clientes TotalPass
const totalPassRestAction = restActionFactory(
  `${constants.BASE_URL}${TOTAL_PASS_BASE_URL}`
);
